"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));

var React = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _mobx = require("mobx");

var _DayPickerInput = _interopRequireDefault(require("react-day-picker/DayPickerInput"));

var _moment = _interopRequireDefault(require("moment/moment"));

var _Popover = _interopRequireDefault(require("../../Popover"));

var _styling = require("../../../toolkit/styling");

var icons = _interopRequireWildcard(require("../../../toolkit/icons"));

var _providers = require("../../../toolkit/providers");

var _DayPicker = _interopRequireDefault(require("./DayPicker"));

var _class, _class2, _descriptor, _descriptor2, _descriptor3, _class3, _temp, _class4, _class5, _class6, _temp2, _class7, _class8, _temp3;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var DEFAULT_FORMAT = "YYYY-MM-DD";

var TextInputForDayPicker = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(TextInputForDayPicker, _Component);

  var _super = _createSuper(TextInputForDayPicker);

  function TextInputForDayPicker() {
    var _this;

    (0, _classCallCheck2["default"])(this, TextInputForDayPicker);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.context = void 0;
    (0, _initializerDefineProperty2["default"])(_this, "hasFocus", _descriptor, (0, _assertThisInitialized2["default"])(_this));
    _this.inputRef = void 0;
    (0, _initializerDefineProperty2["default"])(_this, "onBlur", _descriptor2, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])(_this, "onFocus", _descriptor3, (0, _assertThisInitialized2["default"])(_this));

    _this.handleClickImg = function () {
      _this.focus();
    };

    return _this;
  }

  (0, _createClass2["default"])(TextInputForDayPicker, [{
    key: "focus",
    // This public method is required by the internal lib
    value: function focus() {
      if (this.inputRef) {
        this.inputRef.focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          onBlur = _this$props.onBlur,
          onFocus = _this$props.onFocus,
          noEdit = _this$props.noEdit,
          disabled = _this$props.disabled,
          value = _this$props.value,
          inputProps = (0, _objectWithoutProperties2["default"])(_this$props, ["className", "onBlur", "onFocus", "noEdit", "disabled", "value"]);
      return /*#__PURE__*/React.createElement("div", {
        className: (0, _styling.css)(this.styles.root)
      }, /*#__PURE__*/React.createElement("div", {
        className: (0, _styling.css)(this.styles.inputContainer)
      }, /*#__PURE__*/React.createElement("input", (0, _extends2["default"])({
        type: "text",
        ref: function ref(child) {
          return _this2.inputRef = child;
        },
        className: (0, _styling.css)(this.styles.input),
        onBlur: this.onBlur,
        onFocus: this.onFocus,
        readOnly: noEdit,
        disabled: disabled,
        value: value || ""
      }, inputProps)), /*#__PURE__*/React.createElement("div", {
        className: (0, _styling.css)(this.styles.rightIcon),
        onClick: this.handleClickImg
      }, /*#__PURE__*/React.createElement("img", {
        src: icons.calendar,
        style: {
          maxWidth: "100%",
          maxHeight: "100%"
        },
        draggable: false
      }))));
    }
  }, {
    key: "borderColor",
    get: function get() {
      var _this$context$theming = this.context.theming.theme,
          corePrimary = _this$context$theming.corePrimary,
          borderPrimary = _this$context$theming.borderPrimary;
      return this.hasFocus ? corePrimary : borderPrimary;
    }
  }, {
    key: "styles",
    get: function get() {
      var padding = 14;
      var _this$props2 = this.props,
          noEdit = _this$props2.noEdit,
          disabled = _this$props2.disabled,
          height = _this$props2.height;
      var _this$context$theming2 = this.context.theming,
          _this$context$theming3 = _this$context$theming2.theme,
          textBlack = _this$context$theming3.textBlack,
          surfaceLightest = _this$context$theming3.surfaceLightest,
          fonts = _this$context$theming2.fonts;
      var iconKeyframes = {
        from: {
          transform: "scale(0, 0)",
          opacity: 0.5
        },
        to: {
          transform: "scale(1, 1)",
          opacity: 1
        }
      };
      return _aphrodite.StyleSheet.create({
        root: {
          display: "flex",
          flexDirection: "column"
        },
        inputContainer: {
          display: "flex",
          alignItems: "stretch",
          flexDirection: "row",
          overflow: "hidden",
          height: height ? height : 40,
          padding: "0px ".concat(padding, "px"),
          border: "solid 1px ".concat(this.borderColor),
          borderRadius: 4,
          backgroundColor: surfaceLightest,
          opacity: disabled ? 0.5 : 1
        },
        input: {
          fontSize: 15,
          width: "100%",
          height: height ? height : 40,
          padding: "0px ".concat(padding, "px 0px 0"),
          color: textBlack,
          border: "none",
          backgroundColor: surfaceLightest,
          cursor: noEdit ? "pointer" : "text",
          outline: "none",
          borderColor: "none",
          boxShadow: "none",
          margin: 0,
          fontFamily: fonts.regular
        },
        rightIcon: {
          width: 16,
          animationName: [iconKeyframes],
          animationDuration: "400ms",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer"
        }
      });
    }
  }]);
  return TextInputForDayPicker;
}(React.Component), _class3.contextType = _providers.LegoContext, _temp), (_descriptor = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "hasFocus", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "onBlur", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this3 = this;

    return /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(e) {
        var onBlur;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                onBlur = _this3.props.onBlur;

                if (onBlur) {
                  onBlur(e);
                }

                _this3.hasFocus = false;

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();
  }
}), _descriptor3 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "onFocus", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this4 = this;

    return function (e) {
      var onFocus = _this4.props.onFocus;
      _this4.hasFocus = true;

      if (onFocus) {
        onFocus(e);
      }
    };
  }
}), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "borderColor", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "borderColor"), _class2.prototype), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "styles", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "styles"), _class2.prototype)), _class2)) || _class;

var CustomOverlay = (0, _mobxReact.observer)(_class4 = (_class5 = (_temp2 = _class6 = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(CustomOverlay, _React$Component);

  var _super2 = _createSuper(CustomOverlay);

  function CustomOverlay() {
    var _this5;

    (0, _classCallCheck2["default"])(this, CustomOverlay);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this5 = _super2.call.apply(_super2, [this].concat(args));
    _this5.context = void 0;
    return _this5;
  }

  (0, _createClass2["default"])(CustomOverlay, [{
    key: "render",
    value: function render() {
      var _this6 = this;

      var _this$props3 = this.props,
          alignRight = _this$props3.alignRight,
          selectedDay = _this$props3.selectedDay,
          month = _this$props3.month,
          input = _this$props3.input,
          classNames = _this$props3.classNames,
          childrenElem = _this$props3.children,
          props = (0, _objectWithoutProperties2["default"])(_this$props3, ["alignRight", "selectedDay", "month", "input", "classNames", "children"]);
      var children = childrenElem;
      var _children$props = children.props,
          notUsed = _children$props.classNames,
          locale = _children$props.locale,
          localeUtils = _children$props.localeUtils,
          weekdayElement = _children$props.weekdayElement,
          childrenProp = (0, _objectWithoutProperties2["default"])(_children$props, ["classNames", "locale", "localeUtils", "weekdayElement"]);
      return /*#__PURE__*/React.createElement(_Popover["default"], {
        popoverContent: function popoverContent() {
          return /*#__PURE__*/React.createElement("div", (0, _extends2["default"])({
            className: (0, _styling.css)(_this6.styles.root, {
              padding: 5
            })
          }, props), /*#__PURE__*/React.createElement(_DayPicker["default"], (0, _extends2["default"])({
            selectedDays: selectedDay
          }, childrenProp)));
        },
        position: "bottom center",
        popoverOpen: true
      });
    }
  }, {
    key: "styles",
    get: function get() {
      var _this$context$theming4 = this.context.theming.theme,
          borderPrimaryDark = _this$context$theming4.borderPrimaryDark,
          surfaceLightest = _this$context$theming4.surfaceLightest;
      var alignRight = this.props.alignRight;
      var align = {
        left: 0
      };

      if (alignRight) {
        align = {
          right: 0
        };
      }

      return _aphrodite.StyleSheet.create({
        root: {
          position: "relative"
        },
        inner: _objectSpread({
          position: "absolute",
          padding: "0 18px",
          border: "1px solid ".concat(borderPrimaryDark),
          backgroundColor: surfaceLightest,
          borderRadius: 2,
          top: 0,
          zIndex: 1
        }, align)
      });
    }
  }]);
  return CustomOverlay;
}(React.Component), _class6.contextType = _providers.LegoContext, _temp2), ((0, _applyDecoratedDescriptor2["default"])(_class5.prototype, "styles", [_mobx.computed], Object.getOwnPropertyDescriptor(_class5.prototype, "styles"), _class5.prototype)), _class5)) || _class4;

var DayPickerInput = (0, _mobxReact.observer)(_class7 = (_temp3 = _class8 = /*#__PURE__*/function (_Component2) {
  (0, _inherits2["default"])(DayPickerInput, _Component2);

  var _super3 = _createSuper(DayPickerInput);

  function DayPickerInput() {
    var _this7;

    (0, _classCallCheck2["default"])(this, DayPickerInput);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this7 = _super3.call.apply(_super3, [this].concat(args));
    _this7.context = void 0;
    _this7.inputRef = void 0;
    return _this7;
  }

  (0, _createClass2["default"])(DayPickerInput, [{
    key: "getDisabledStyle",
    value: function getDisabledStyle() {
      var theme = this.context.theming.theme;

      if (_DayPicker["default"].disabledStyle.hasOwnProperty("disabled")) {
        return _DayPicker["default"].disabledStyle;
      }

      var styles = _aphrodite.StyleSheet.create({
        disabled: {
          color: "".concat(theme.textBlack, " !important"),
          // @ts-ignore "0.2 !important" is a hack to
          // insert !important into daypicker library.
          opacity: "0.2 !important",
          cursor: "default !important",
          ":hover": {
            background: "none !important"
          }
        }
      });

      _DayPicker["default"].disabledStyle.disabled = (0, _styling.css)(styles.disabled);
      return _DayPicker["default"].disabledStyle;
    }
  }, {
    key: "getInput",
    value: function getInput() {
      if (this.inputRef) {
        return this.inputRef.getInput();
      }

      return null;
    }
  }, {
    key: "disableDaysFromToday",
    value: function disableDaysFromToday(mergeDayPickerProps, isBefore) {
      if (mergeDayPickerProps === undefined) {
        return;
      }

      var disabledModifier = isBefore ? {
        before: new Date()
      } : {
        after: new Date()
      };

      if (!mergeDayPickerProps.hasOwnProperty("disabledDays")) {
        mergeDayPickerProps.disabledDays = disabledModifier;
      } else {
        var disabledDays = mergeDayPickerProps.disabledDays;

        if (Array.isArray(disabledDays)) {
          mergeDayPickerProps.disabledDays = [].concat((0, _toConsumableArray2["default"])(disabledDays), [disabledModifier]);
        } else {
          mergeDayPickerProps.disabledDays = [disabledDays, disabledModifier];
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this8 = this;

      var _this$props4 = this.props,
          placeholder = _this$props4.placeholder,
          alignRight = _this$props4.alignRight,
          noEdit = _this$props4.noEdit,
          disabled = _this$props4.disabled,
          cannotSelectFuture = _this$props4.cannotSelectFuture,
          cannotSelectPast = _this$props4.cannotSelectPast,
          component = _this$props4.component,
          overlayComponent = _this$props4.overlayComponent,
          inputProps = _this$props4.inputProps,
          dayPickerProps = _this$props4.dayPickerProps,
          displayFormat = _this$props4.displayFormat,
          formatDate = _this$props4.formatDate,
          parseDate = _this$props4.parseDate,
          height = _this$props4.height,
          className = _this$props4.className,
          style = _this$props4.style,
          props = (0, _objectWithoutProperties2["default"])(_this$props4, ["placeholder", "alignRight", "noEdit", "disabled", "cannotSelectFuture", "cannotSelectPast", "component", "overlayComponent", "inputProps", "dayPickerProps", "displayFormat", "formatDate", "parseDate", "height", "className", "style"]);
      var mergeInputProps = inputProps || {};
      mergeInputProps.noEdit = noEdit;
      mergeInputProps.disabled = disabled;
      mergeInputProps.height = height;
      var mergeDayPickerProps = dayPickerProps || {}; // Have to set the disabled style in className,
      // so that it handles the disabled state correctly.
      // Because internally, the lib uses the class name to
      // determine whether it's disabled

      mergeDayPickerProps.classNames = this.getDisabledStyle(); // Have to set all required class names,
      // otherwise the browser will show error.

      var otherRequiredClassNames = ["container", "wrapper", "interactionDisabled", "navBar", "navButtonPrev", "navButtonNext", "navButtonInteractionDisabled", "months", "month", "caption", "weekdays", "weekdaysRow", "weekday", "weekNumber", "body", "week", "day", "footer", "todayButton", "today", "selected", "outside"];

      for (var _i = 0, _otherRequiredClassNa = otherRequiredClassNames; _i < _otherRequiredClassNa.length; _i++) {
        var name = _otherRequiredClassNa[_i];

        // none of the class names actually matters.
        // the DayPicker component will ignore all of them
        if (mergeDayPickerProps.classNames != null) {
          mergeDayPickerProps.classNames[name] = "";
        }
      }

      if (cannotSelectFuture) {
        this.disableDaysFromToday(mergeDayPickerProps, false);
      } else if (cannotSelectPast) {
        this.disableDaysFromToday(mergeDayPickerProps, true);
      }

      if (cannotSelectPast) {
        if (!mergeDayPickerProps.hasOwnProperty("disabledDays")) {
          mergeDayPickerProps.disabledDays = {
            before: new Date()
          };
        } else {
          var disabledDays = mergeDayPickerProps.disabledDays;

          if (Array.isArray(disabledDays)) {
            mergeDayPickerProps.disabledDays = [].concat((0, _toConsumableArray2["default"])(disabledDays), [{
              before: new Date()
            }]);
          } else {
            mergeDayPickerProps.disabledDays = [disabledDays, {
              before: new Date()
            }];
          }
        }
      }

      var computedDisplayFormat = displayFormat || DEFAULT_FORMAT;

      var computedFormatDate = formatDate || function (date, format) {
        return (0, _moment["default"])(date).format(format);
      };

      var computedParseDate = parseDate || function (str, format) {
        return (0, _moment["default"])(str, format).toDate();
      };

      return /*#__PURE__*/React.createElement("div", {
        className: (0, _styling.css)(style, className)
      }, /*#__PURE__*/React.createElement(_DayPickerInput["default"], (0, _extends2["default"])({
        ref: function ref(input) {
          _this8.inputRef = input;
        },
        formatDate: computedFormatDate,
        parseDate: computedParseDate,
        format: computedDisplayFormat,
        component: TextInputForDayPicker,
        overlayComponent: function overlayComponent(props) {
          return /*#__PURE__*/React.createElement(CustomOverlay, (0, _extends2["default"])({
            alignRight: alignRight
          }, props));
        },
        placeholder: placeholder || computedDisplayFormat,
        inputProps: mergeInputProps,
        dayPickerProps: mergeDayPickerProps
      }, props)));
    }
  }]);
  return DayPickerInput;
}(React.Component), _class8.contextType = _providers.LegoContext, _class8.propDoc = {
  alignRight: {
    required: false,
    defaultValue: "false",
    type: "boolean",
    description: "Indicates the day picker window should align right"
  },
  noEdit: {
    required: false,
    defaultValue: "false",
    type: "boolean",
    description: "Indicates that user cannot manually type in the date"
  },
  disabled: {
    required: false,
    defaultValue: "false",
    type: "boolean",
    description: "Indicates that the input is disabled"
  },
  cannotSelectFuture: {
    required: false,
    defaultValue: "false",
    type: "boolean",
    description: "Indicates that the days after today cannot be selected"
  },
  cannotSelectPast: {
    required: false,
    defaultValue: "false",
    type: "boolean",
    description: "Indicates that the days before today cannot be selected"
  },
  displayFormat: {
    required: false,
    defaultValue: DEFAULT_FORMAT,
    type: "(string | null)",
    description: "Format used to display the date"
  },
  height: {
    required: false,
    defaultValue: "40px",
    type: "?number",
    description: "Height of input field"
  }
}, _class8.demoProps = {
  showOverlay: true,
  alignRight: true,
  noEdit: true,
  cannotSelectFuture: true,
  onDayChange: function onDayChange() {},
  dayPickerProps: {
    showOutsideDays: true
  }
}, _class8.discussion = "\n  ## A wrapper for a 3rd-party component `react-day-picker`\n  _using our wrapped DayPicker_\n\n  Did some modifications to satisfy our request\n\n  For other props, please check\n  http://react-day-picker.tsx.org/api/DayPickerInput.\n\n  The following props are ignored:\n  - `component`\n  - `overlayComponent`\n  - `dayPickerProps.classNames`\n  ", _temp3)) || _class7;

var _default = DayPickerInput;
exports["default"] = _default;